import React, {useCallback, useState, useEffect, useMemo} from 'react';
import propTypes from 'prop-types';
import styled from '@emotion/styled';
import {get, debounce} from 'lodash';
import {FormControlLabel, RadioGroup, ButtonBase} from '@mui/material';
// import {ReactSVG} from 'react-svg';
import Router from 'next/router';

import Accordion from '../../components/ui/NewAccordion';
import Checkbox from '../../components/forms/WhiteCheckbox';
import Radio from '../../components/forms/Radio';
import Slider from '../../components/ui/Slider';
import Text from '../../components/typography';
import {theme} from '../../themes/default-theme';
// import {Links} from '../../components/ui';
// import close from '../../../src/assets/icons/close.svg';
// import plus from '../../../src/assets/icons/plus.svg';
import Link from 'next/link';
import NewDropdown from '../../components/ui/NewDropdown';

const CheckboxItem = styled.div`
  text-transform: uppercase;
  padding-left: 8px;

  .MuiFormGroup-root label > span {
    padding: 4px;
  }
`



const AccordionItem = styled.div` 
  margin-bottom: 1px;
  ${theme.breakpoints.down("md")} {
    button {
      background-color: white!important;
    }
  }
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 18px;

  ${theme.breakpoints.up("md")} {
    padding-bottom: 32px;
  }

  h6 {
    margin-bottom: 0;
  }

  a {
    text-decoration: none;
    font-size: 15px;
    color: ${theme.palette.skyBlue};
  }
`

const Locations = styled.div`

`

const LocationsTitle = styled(ButtonBase)`
  width: 100%;
  height: 50px;
  background: ${theme.palette.lightGrey};
  padding: 14px 0;
  display: block;
`

const LocationHeading =  styled(props => {
  return <Text {...props} />
})`
  & {
    ${props => props.size === 'small' ? `
      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: 2px;
    `: `font-size: 20px;`}
    font-weight: 700;
    display: flex;
    align-items: center;
    text-align: left;
    color: ${theme.palette.charcoal};
    ${theme.breakpoints.down('sm')} {
    ${props => props.size === 'small' ? `
      font-size: 14px;
      margin: 8px;
    `: `font-size: 14px;
      margin: 8px;  
    `
    }
      font-weight: 600;
    }
  }
`;

const LocationsIcon = styled.span`
  width: 24px;
  height: 24px;
  margin-right: 0px;
  color: #fff;
  border: 1px solid #fff;
  display: block;
  position: absolute;
  top: 15px;
  right: 17px;
  border-radius: 24px;
  background-color: #F7F8FA;

  svg {
    text-align: center;
    width: auto;
    height: 12px;
    display: block;
    margin-left: 5px;
    margin-top: 5px;
  }
`

const LocationItems = styled.div`
  padding: 0 0 6px;
`

const LocationItem = styled.div`
  margin-bottom: 12px;

  a {
    text-decoration: none;
  }

  svg {
    path {
      stroke: white
    }
  }

  span {
    color: ${theme.palette.gunmentalGrey};
    font-size: 16px;
    text-transform: capitalize;
  }

`

const SliderWrapper = styled.div`
  width: 100%;
`

const Deselect = styled(ButtonBase)`
  text-decoration: underline;
  margin-bottom: 14px;
`

const forSaleFilterDefaultPropFilters = {};
const forSaleFilterDefaultPropOnClear = () => {};

const ForSaleFilter = (props) => {
  props = {
    ...props,
    categoryType: typeof props.categoryType === "undefined" ? 'checkbox' : props.categoryType,
    category: typeof props.category === "undefined" ? null : props.category,
    locations: typeof props.locations === "undefined" ? null : props.locations,
    filters: typeof props.filters === "undefined" ? forSaleFilterDefaultPropFilters : props.filters,
    onClear: typeof props.onClear === "undefined" ? forSaleFilterDefaultPropOnClear : props.onClear
  };

  const {
    filters,
    onFilterChange,
    onClear,
    regions,
    state,
    category,
    onClearItem
  } = props;

  const [activeState, setActiveState] = useState(state);

  const handleClear = (e) => {
    e.preventDefault();
    onClear();
  }

  const handleClearItem = (type) => {
    if (onClearItem) {
      onClearItem(type);
    }
  }

  const handleFilterChange = (accordion, type, event) => {
    onFilterChange(accordion, type, event)
  }

  const handleLocationPopup = (val) => {
    props.onModal(val)
  }

  const handleSliderChange = (type, val) => {
    onFilterChange(type, null, null, val)
  };

  const handleModelChange = (type, event) => {
    onFilterChange('models', type, event)
  }

  const debounceSliderChange = useCallback(
    debounce(handleSliderChange, 500)
  , [filters]);

  // after unmounting
  useEffect(() => {
    return () => {
      debounceSliderChange.cancel();
    }
  }, []);

  const activeBrands = get(filters, 'brands', []).filter(item => item.checked);

  const states = [{
    text: 'All',
    value: 'all',
    url: `/for-sale/${category}`
  },{
    text: 'Australian Capital Territory',
    value: 'act',
    url: `/for-sale/${category}/act`
  },{
    text: 'New South Wales',
    value: 'nsw',
    url: `/for-sale/${category}/nsw`
  },{
    text: 'Northern Territory',
    value: 'nt',
    url: `/for-sale/${category}/nt`
  },{
    text: 'Queensland',
    value: 'qld',
    url: `/for-sale/${category}/qld`
  },{
    text: 'South Australia',
    value: 'sa',
    url: `/for-sale/${category}/sa`
  },{
    text: 'Tasmania',
    value: 'tas',
    url: `/for-sale/${category}/tas`
  },{
    text: 'Victoria',
    value: 'vic',
    url: `/for-sale/${category}/vic`
  },{
    text: 'Western Australia',
    value: 'wa',
    url: `/for-sale/${category}/wa`
  }]

  console.log('filters', filters);

  return (
    <div>
      <AccordionItem>
        <Accordion 
          title='Locations' 
          id="location-category" 
          size="small" 
          activeBg="middleGrey" 
          defaultExpanded={true} 
          border={true} 
          variant="secondary">

          <NewDropdown
            variant="outlined"
            // showComplete={true}
            // error={get(errors, `[dealer]`, false) ? true : false}
            label={activeState ? activeState.toLowerCase() : 'All'}
            defaultValue={activeState ? activeState.toLowerCase() : undefined}
            value={activeState ? activeState.toLowerCase() : undefined}
            options={states}
            onChange={(val) => {
              setActiveState(val.value)
              Router.push(val.url.toLowerCase());
              console.log('state...', val);
            }}
          />
            
        </Accordion>
      </AccordionItem>
      <AccordionItem>
        <Accordion title='Price' id="stock-price" size="small" activeBg="middleGrey" defaultExpanded={true} border={true} variant="secondary">
          <div>
            {filters && filters.price && filters.price.max > 0 &&
              <SliderWrapper key={props.id + 'year'}>  
                <Slider
                  //
                  id="price"
                  type="price"
                  defaultVals={get(filters, 'price.val', [20000, 100000])}
                  min={get(filters, 'price.min', 10000)}
                  max={get(filters, 'price.max', 100000)}
                  step={1}
                  inputSize="fullWidth"
                  onSliderChange={(val) => debounceSliderChange('price', val)}
                />
              </SliderWrapper>
            }
          </div>
        </Accordion>
      </AccordionItem>
      {get(filters, 'types', []).length > 2 &&
        <AccordionItem>
          <Accordion title='Type' id="stock-type" size="small" activeBg="middleGrey" defaultExpanded={true} border={true} variant="secondary">
            <div>
              <Deselect onClick={() => handleClearItem('types')}>Deselect All</Deselect>
              {get(filters, 'types', []).map(item => (
                <CheckboxItem key={item.value}>
                  <Checkbox
                    checked={item.checked}
                    label={item.text}
                    onChange={(event) => handleFilterChange('types', item.value, event)}
                    name={`type_${item.value}`}
                  />
                </CheckboxItem>
              ))}
            </div>
          </Accordion>
        </AccordionItem>
      }
      <AccordionItem>
        <Accordion title='Category' id="stock-category" size="small" activeBg="middleGrey" defaultExpanded={false} border={true} variant="secondary">
          <div>
            {get(filters, 'categories', []).map(item => (
              <CheckboxItem key={item.value}>
                {props.categoryType === 'radio' ? 
                  <RadioGroup name="categories">
                    <FormControlLabel value={item.value} control={
                      <Radio
                        checked={item.checked}
                        label={item.text}
                        onChange={(event) => handleFilterChange('categories', item.value, event)}
                        name={`category_${item.value}`}
                      />
                    } label={item.text} />
                  </RadioGroup>
                :
                  <Checkbox
                    checked={item.checked}
                    label={item.text}
                    onChange={(event) => handleFilterChange('categories', item.value, event)}
                    name={`category_${item.value}`}
                  />
                }
              </CheckboxItem>
            ))}
          </div>
        </Accordion>
      </AccordionItem>
      {process.env.DEALER_SITE &&
        <AccordionItem>
          <Accordion title='Brand' id="stock-brand" size="small" activeBg="middleGrey" defaultExpanded={false} border={true} variant="secondary">
            <div>
              <Deselect onClick={() => handleClearItem('brands')}>Deselect All</Deselect>
              {get(filters, 'brands', []).map(item => (
                <CheckboxItem key={item.value}>
                  <Checkbox
                    checked={item.checked}
                    label={item.text}
                    onChange={(event) => handleFilterChange('brands', item.value, event)}
                    name={`brand_${item.value}`}
                    // disabled={item.checked === true && activeBrands.length === 1}
                  />
                </CheckboxItem>
              ))}
            </div>
          </Accordion>
        </AccordionItem>
      }
      <AccordionItem>
        <Accordion title='Models' id="stock-models" size="small" activeBg="middleGrey" defaultExpanded={false} border={true} variant="secondary">
          <div>
            <Deselect onClick={() => handleClearItem('models')}>Deselect All</Deselect>

            {get(filters, 'models', []).map(item => (
              <CheckboxItem key={item.value}>
                <Checkbox
                  checked={item.checked}
                  label={item.text}
                  onChange={(event) => handleModelChange(item.value, event)}
                  name={`model_${item.value}`}
                />
              </CheckboxItem>
            ))}
          </div>
        </Accordion>
      </AccordionItem>
      <AccordionItem>
        <Accordion title='Year' id="stock-year" size="small" activeBg="middleGrey" defaultExpanded={false} border={true} variant="secondary">
          <div>
            {filters && filters.year && filters.year.max > 0 &&
              <SliderWrapper key={props.id + 'year'}>
                <Slider
                  //
                  id="year"
                  type="regular"
                  defaultVals={get(filters, 'year.val', [1992, 2020])}
                  min={get(filters, 'year.min', 1991)}
                  max={get(filters, 'year.max', 2020)}
                  step={1}
                  inputSize="fullWidth"
                  onSliderChange={(val) => debounceSliderChange('year', val)}
                />
              </SliderWrapper>
            }
          </div>
        </Accordion>
      </AccordionItem>
      {regions.length > 0 &&
      <AccordionItem>
        <Accordion title='More Locations' id="more-location-category" size="small" activeBg="middleGrey" defaultExpanded={false} border={true} variant="secondary">
          <LocationItems>
            {regions.map((item, index) => (
              <LocationItem key={item.region}>
                <Text>
                  <Link href={item.link ? item.link : '#'}>

                    <span>{item.region}</span>

                  </Link>
                </Text>
              </LocationItem>
            ))}
          </LocationItems>
        </Accordion>
      </AccordionItem>
      }
    </div>
  );
}

ForSaleFilter.propTypes = {
  categoryType: propTypes.string,
  category: propTypes.string,
  locations: propTypes.array,
  filters: propTypes.object,
  onClear: propTypes.func
}

export default ForSaleFilter